/* src/app/shared/protocolo-ipd/protocolo-listar-ipd/protocolo-listar-ipd.component.scss */
/*# sourceMappingURL=protocolo-listar-ipd.component.css.map */
